import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from 'store/reducers/auth/slice';
import Request from 'common/network/Request';
import { Controller, useForm } from 'react-hook-form';
import { Button, Form, Input, message, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import userApi from 'modules/auth/api';
import { LoginOutlined } from '@ant-design/icons';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth?.token);

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  const handleLogin = async (data) => {
    const { sale_code, password } = data;
    setLoading(true);
    message.destroy();
    try {
      const response = await Request.post(userApi.login, {
        sale_code,
        password,
      });

      if (response && response?.success) {
        message.success('Đăng nhập thành công.');
        dispatch(login(response?.result));
        navigate('/');
      } else {
        const mess =
          response?.message || 'Đăng nhập thất bại. Vui lòng thử lại.';
        notification.error({
          message: 'Lỗi',
          description: mess,
        });
        setErrorMessage(mess);
      }
    } catch (error) {
      const errorMessage =
        error.response?.message || 'Đăng nhập thất bại. Vui lòng thử lại.';
      notification.error({
        message: 'Lỗi',
        description: errorMessage,
      });
      setErrorMessage(errorMessage);
    }
    setLoading(false);
  };

  if (token) {
    navigate('/');
    return null;
  }

  return (
    <section className="h-full background-auth-image">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto h-full lg:py-0">
        <div className="w-full bg-white rounded-lg shadow-aesthetic md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
              Đăng nhập tài khoản
            </h1>
            <Form
              onFinish={handleSubmit(handleLogin)}
              layout="vertical"
              className="space-y-2 md:space-y-4"
              action="#"
            >
              <Form.Item
                label="Mã TVV"
                validateStatus={errors.sale_code ? 'error' : ''}
                help={errors.sale_code?.message}
              >
                <Controller
                  control={control}
                  name="sale_code"
                  rules={{ required: 'Hãy nhập mã TVV!' }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      autoComplete="username"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 p-2.5"
                      placeholder="Nhập mã TVV"
                    />
                  )}
                />
              </Form.Item>
              <Form.Item
                label="Mật khẩu"
                validateStatus={errors.password ? 'error' : ''}
                help={errors.password?.message}
              >
                <Controller
                  control={control}
                  name="password"
                  rules={{ required: 'Hãy nhập mật khẩu!' }}
                  render={({ field }) => (
                    <Input.Password
                      {...field}
                      autoComplete="current-password"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 p-2.5"
                      placeholder="••••••••"
                    />
                  )}
                />
              </Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                className="px-5 py-5 font-medium !mt-6"
                loading={loading}
                icon={<LoginOutlined />}
              >
                Đăng nhập
              </Button>
              {errorMessage && (
                <div
                  className="py-2 px-4 mt-4 text-sm text-red-800 rounded-lg bg-red-50"
                  role="alert"
                >
                  <span className="">{errorMessage}</span>
                </div>
              )}
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
